import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { usePostJobNavigation } from 'parent-portal/jobs/postJob/usePostJobNavigation';
import { TextButton } from 'library/ui';

export const EditDraft = ({ jobId }: { jobId: number; onClose: () => void }) => {
    const { goToDraft } = usePostJobNavigation();

    return (
        <TextButton onClick={() => goToDraft('Edit Draft', jobId)}>
            <EditIcon id="more-options-edit-draft" sx={{ fontSize: 16 }} />
            Edit Draft
        </TextButton>
    );
};
